<template>
	<div class="mainBox">
		<div class="topNav">
			<van-nav-bar ref="nav" safe-area-inset-top :placeholder="true" :fixed="true" title="项目列表" left-text="返回" left-arrow @click-left="goBack">
			</van-nav-bar>
		</div>
		<form action="/">
			<van-sticky :offset-top="navbarHeight">
				<van-search
				v-model="keyWord"
				shape="round"
				placeholder="请输入搜索关键词"
				:clearable="true"
				@search="onRefresh"
				@clear="onClear"
				/>
			</van-sticky>
		</form>
		<!-- 下拉刷洗 -->
		<van-pull-refresh v-model="isRefreshLoading" success-text="刷新成功" @refresh="onRefresh">

			<!-- 触底继续加载 -->
			<van-list
				v-model="loading"
				:finished="finished"
				finished-text="没有更多了"
				:error.sync="error"
				error-text="请求失败，点击重新加载"
				@load="loadMore"
			>
				<div class="projectItem" v-for="item in dataList" @click="goWorkbench(item)">
					<div class="itemRow">
						<div class="label">工作控制号</div>
						<div class="value">{{item.workNo}}</div>
					</div>
					<div class="itemRow">
						<div class="label">项目名称</div>
						<div class="value">{{item.projectName}}</div>
					</div>
					<div class="itemRow">
						<div class="label">委托方</div>
						<div class="value">{{item.projectEntrust}}</div>
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</template>

<script>
	import { syslogin, projectList } from '@/api/project';
	import common from '../utils/common';
	import { Notify } from 'vant';
	export default {
		name: 'projectList',
		data() {
			return {
				isRefreshLoading: false,
				error: false,
				loading: false,
				finished: false,
				page: 0,
				limit: 10,
				dataList: [],
				user:{
					"userId": null,
					"username": null,
					"password": null,
					"salt": null,
					"email": null,
					"mobile": null,
					"status": null,
					"roleIdList": null,
					"createUserId": null,
					"createTime": null,
					"relationId": null,
					"companyId": null
				},
				// 搜索框内容
				keyWord: null,
				navbarHeight:0,
				token:null,
				appid:null,
				secretKey:null,
			}
		},
		mounted() {
			// console.log("00000000");
			this.token = common.getToken();
			this.appid = this.$route.params.appid;
			this.secretKey = this.$route.params.secretkey;
			if(this.appid != null && this.appid != undefined && this.appid != 'undefined'
						&& this.secretKey != null && this.secretKey != undefined && this.secretKey != 'undefined') {
				this.token = null;
				common.setToken('');
				// this.onLoad()
			}
			this.navbarHeight = this.$refs.nav.height;//吸顶的距离
			if (this.navbarHeight < 60) {
				this.navbarHeight += 30;
			}
		},
		created() {
		},
		methods: {
			goBack() {
				common.setToken('');
				alert('CjsBackToLastPage');
			},
			async login(appid, secretKey) {
				let data = {
					appId: appid,
					secretKey: secretKey
				}
				await syslogin(data).then(response =>{
					if (response.data.resultCode === 200){
						common.setToken(response.data.token);
						common.setUser(response.data.user);
						common.setPermision(response.data.permissions);
						this.token = response.data.token;
						console.log("login success");
						this.getProjectList()
					} else {
						Notify({ type: 'danger', message: "授权失败" });
						console.log("login fail");
					}
				});

			},
			goWorkbench(item){
				common.setProject(item);
				this.$router.push({name:'workbench'});
			},
			onRefresh(){
				// console.log("77777");
				this.finished = false;
				this.loading = true;
				this.page = 1;
				this.dataList = [];
				this.onLoad();
			},
			onClear(){
				this.keyWord = '';
			},
			loadMore(){
				// console.log("8888888");
				this.page += 1;//页数+1
      			this.onLoad();
			},
			getProjectList(){
				let data = {
					page: this.page,
					limit: this.limit,
					keyWord: this.keyWord
				}
				if (this.isRefreshLoading){
					data.page = 1;
					this.dataList = [];
					this.isRefreshLoading = false;
				}
				console.log("get project list ...");
				projectList(data).then(response => {
					this.loading = false;
					if (response.data.resultCode === 200){
						this.dataList = this.dataList.concat(response.data.body.records);
						if (response.data.body.records.length === 0) {
							this.finished = true;
						}
					}else{
						this.finished = true;
					}
				})
			},
			async onLoad(){
				if (this.token == null || this.token == '') {
					if(this.appid != null && this.appid != undefined && this.appid != 'undefined'
						&& this.secretKey != null && this.secretKey != undefined && this.secretKey != 'undefined') {
							await this.login(this.appid, this.secretKey);
					} else {
						Notify({ type: 'danger', message: "未获得授权"});
						return;
					}
				} else {
					this.getProjectList()
				}

			}
		}
	}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>
